export const Colors = {
  background: '#101419',
  foreground: '#ffffff',
  section: '#1B2026',
  footer: '#09090b',
  primary: {
    DEFAULT: '#FF3D00',
    hover: '#FF5A26',
    text: '#FF5B00',
    foreground: '#ffffff',
  },
  secondary: {
    DEFAULT: '#21854E',
    hover: '#379160',
    text: '#32C275',
    foreground: '#ffffff',
  },
  success: '#22c55e',
  error: '#ef4444',
  accent: {
    DEFAULT: '#ffe500',
    foreground: '#000000',
  },
};
